var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2461 12.1831L10.5967 4.83244L17.9474 12.1831C18.1228 12.3585 18.331 12.4976 18.5602 12.5925C18.7894 12.6875 19.035 12.7363 19.283 12.7363C19.5311 12.7363 19.7767 12.6875 20.0059 12.5925C20.235 12.4976 20.4432 12.3585 20.6186 12.1831C20.794 12.0077 20.9332 11.7995 21.0281 11.5703C21.123 11.3411 21.1719 11.0955 21.1719 10.8475C21.1719 10.5994 21.123 10.3538 21.0281 10.1246C20.9332 9.89548 20.794 9.68725 20.6186 9.51185L11.9229 0.816107C11.184 0.0772525 9.99051 0.0772524 9.25166 0.816107L0.55591 9.51185C0.380284 9.68712 0.240948 9.8953 0.14588 10.1245C0.050812 10.3537 0.00187511 10.5994 0.00187509 10.8475C0.00187507 11.0956 0.0508119 11.3413 0.14588 11.5705C0.240948 11.7996 0.380283 12.0078 0.55591 12.1831C1.29476 12.903 2.50724 12.9219 3.2461 12.1831Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrowUp);
export default __webpack_public_path__ + "static/media/expand_arrow_up.b333d7e5a6bdbcb1fe3b9aa35a8269f8.svg";
export { ForwardRef as ReactComponent };